// extracted by mini-css-extract-plugin
export default {"circleScaleWrapper":"RoundScale_circleScaleWrapper__CIzbl","text":"RoundScale_text__4JSli","scale":"RoundScale_scale__XOSls","stroke":"RoundScale_stroke__r7rJz"};